const { default: Swiper } = require('swiper');
const { Autoplay } = require('swiper/modules');

const sections = document.querySelectorAll('section.distinctions');

if (sections.length) {
    sections.forEach(section => {
        const swiperEl = section.querySelector('.swiper');
        if (swiperEl) {
            const swiper = new Swiper(swiperEl, {
                modules: [Autoplay],
                slidesPerView: 8,
                loop: true,
                allowTouchMove: false,
                autoplay: {
                    disableOnInteraction: false,
                    delay: 1,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 2,
                        spaceBetween: 22,
                    },
                    560: {
                        slidesPerView: 6,
                    },
                    1024: {
                        slidesPerView: 8,
                        spaceBetween: 32,
                    },
                },
                speed: 5000,
            });
        }
    });
}
